import { render, staticRenderFns } from "./OrderResults.vue?vue&type=template&id=185a80de&scoped=true&"
import script from "./OrderResults.vue?vue&type=script&lang=js&"
export * from "./OrderResults.vue?vue&type=script&lang=js&"
import style0 from "./OrderResults.vue?vue&type=style&index=0&id=185a80de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a80de",
  null
  
)

export default component.exports